import { QuestionType } from '@empathy/survey/base';

export const QuestionTypeChangeOptions: Partial<Record<QuestionType, QuestionType[]>> = {
  [QuestionType.SingleChoice]: [QuestionType.MultiChoice],
  [QuestionType.MultiChoice]: [QuestionType.SingleChoice],
  [QuestionType.Carousel]: [QuestionType.CarouselMultiChoice, QuestionType.CarouselRating],
  [QuestionType.CarouselMultiChoice]: [QuestionType.Carousel, QuestionType.CarouselRating],
  [QuestionType.CarouselRating]: [QuestionType.Carousel, QuestionType.CarouselMultiChoice],
  [QuestionType.Input]: [QuestionType.Essay],
  [QuestionType.Essay]: [QuestionType.Input],
  [QuestionType.Ranking]: [QuestionType.RankSort],
  [QuestionType.RankSort]: [QuestionType.Ranking]
};
